/**
 * Identifies duplicates in column.
 * It ignores custom header rows.
 * 
 * @param {any} row
 * @param {any} col
 * @param {any} cell
 * @param {any} prop
 * @param {any} table
 * @param {any} cellProperties
 */
export default function (row, col, cell, prop, table, cellProperties) {
    // ignore custom header area
    const customHeaderRows = table.customHeaderRows;
    if (typeof (customHeaderRows) === "number" && row <= customHeaderRows) {
        return;
    }

    if (cell) {
        if (cell.duplicity === true) {
            cellProperties.className = "duplicity";
        }
        else if (cell.duplicity === false) {
            removeClass(cell, "duplicity");
        }
    }
}

function removeClass(cell, className) {
    if (cell && cell.className && cell.className.replace) {
        cell.className = cell.className.replace(className, "");
    }
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/cellprocessors/duplicitiesProcessor.js